// extracted by css-extract-rspack-plugin
export default {"root":"dZWtbv","cover":"RjxTkZ","middle":"kdy7Pt","mature-block":"VJxtLs","matureBlock":"VJxtLs","underlay":"UftfQL"};